<script>
import DynamicElementWithContext from "%/dynamic-components/render-engine/mixins/production/dynamic-element-with-context-mixin";
import ButtonElement
  from "%/dynamic-components/render-engine/components/production/elements/button-element/ButtonElement.vue";
import { resolveProductionVisibility }
  from "%/dynamic-components/render-engine/mixins/production/appearance-mixin-production";

const ACTION_TRIGGER_OPTION = "default.action-trigger";
const FIRE_WHEN_SHOWN = "shown";

export default {
  name: "DynamicAppButtonElement",
  elementPanelSettings: {
    displayIcon: "button",
    elementType: "element",
    elementGroup: "general",
  },
  extends: ButtonElement,
  mixins: [DynamicElementWithContext],
  inject: {
    injectedScopedProvidedContexts: {
      from: "scopedProvidedContexts",
      default: null,
    },
  },
  hidden: true,
  computed: {
    firesWhenShown() {
      return this.getOptionValue(ACTION_TRIGGER_OPTION) === FIRE_WHEN_SHOWN;
    },
    shouldRenderButton() {
      return !this.firesWhenShown;
    },
    isShownToFire() {
      return this.firesWhenShown && resolveProductionVisibility(this);
    },
  },
  watch: {
    isShownToFire: {
      immediate: true,
      handler(shown) {
        if (shown) {
          this.executeAction(null);
        }
      },
    },
  },
  methods: {
    handleButtonClick(e) {
      this.executeAction(e);
    },
  },
};
</script>
